import React, { useEffect, useState } from "react";
import "./Partners.scss";
import axie from "../../assets/images/axie.png";
import hike from "../../assets/images/hike.png";
import mpl from "../../assets/images/mpl.png";
import cblades from "../../assets/images/cblades.png";
import pattern from "../../assets/images/Pattern.png";
import lion from "../../assets/images/lion.png";
import { motion, useTransform, useViewportScroll } from "framer-motion";

function Partners() {
  const [delay, setdelay] = useState(0.5);
  useEffect(() => {
    if (window.innerWidth < 991) {
      setdelay(0);
    } else {
      setdelay(0.5);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 991) {
        setdelay(0);
      } else {
        setdelay(0.5);
      }
    });
  });
  const { scrollYProgress } = useViewportScroll();
  const scale = useTransform(scrollYProgress, [0, delay], [0.5, 1]);
  const opacity = useTransform(scrollYProgress, [0, delay], [0, 1]);
  return (
    <section className="partners">
      <img src={pattern} alt="" className="pattern" />

      <img src={lion} alt="" className="lion" />

      <div className="container">
        <motion.h2 className="secheading upheav " style={{ scale, opacity }}>
          Our Partners
        </motion.h2>

        <motion.div className="partner-grid" style={{ scale, opacity }}>
          <PartnerItem image={hike} />
          <PartnerItem image={mpl} />

          <PartnerItem image={cblades} />
          <PartnerItem image={hike} />
          <PartnerItem image={mpl} />
          <PartnerItem image={cblades} />
        </motion.div>
      </div>
    </section>
  );
}

export default Partners;

const PartnerItem = ({ image }) => {
  return (
    <div className="partner-item">
      <div className="partner-inner">
        <img src={image} alt="" loading="lazy" />
      </div>
    </div>
  );
};
